import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconError';
/** Renders an SVG icon. */
const SvgError = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path fill="currentColor" d="M10 15a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2z" />
      <path
        fill="currentColor"
        d="M21.586 4H10.414L4 10.414v11.172L10.414 28h11.172L28 21.586V10.414zM30 21.586A2 2 0 0 1 29.414 23L23 29.414a2 2 0 0 1-1.414.586H10.414A2 2 0 0 1 9 29.414L2.586 23A2 2 0 0 1 2 21.586V10.414A2 2 0 0 1 2.586 9L9 2.586A2 2 0 0 1 10.414 2h11.172A2 2 0 0 1 23 2.586L29.414 9A2 2 0 0 1 30 10.414z"
      />
    </svg>
  );
};
SvgError.displayName = displayName;
export default SvgError;
